export default __webpack_public_path__ + "static/media/silhouette-girl1.746fb527.svg";